import { logger } from '@/modules/common/logging/logger';

import { AreaPickerStartOptions, IAreaPickerService } from './IAreaPickerService';

export class AreaPickerServiceLogDecorator implements IAreaPickerService {
  private decoree: IAreaPickerService;

  constructor(decoree: IAreaPickerService) {
    this.decoree = decoree;
  }

  start(options: AreaPickerStartOptions): symbol {
    const start = this.logStart(`start (${options.enabledAreaIds.length} areas)`);
    const token = this.decoree.start(options);
    this.logEnd('start', start);
    return token;
  }

  complete(areaId: string): void {
    const start = this.logStart(`complete (${areaId})`);
    this.decoree.complete(areaId);
    this.logEnd(`complete (${areaId})`, start);
  }

  refresh(enabledAreaIds: string[]): void {
    const start = this.logStart(`refresh (${enabledAreaIds.length} areas)`);
    this.decoree.refresh(enabledAreaIds);
    this.logEnd('refresh', start);
  }

  cancel(token: symbol): void {
    const start = this.logStart('cancel');
    this.decoree.cancel(token);
    this.logEnd('cancel', start);
  }

  abort(): void {
    const start = this.logStart('abort');
    this.decoree.abort();
    this.logEnd('abort', start);
  }

  isActive(): boolean {
    return this.decoree.isActive();
  }

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> AreaPicker.${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> AreaPicker.${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
